module.exports = __webpack_public_path__ + "img/illu-rope.6b578384.svg";